import { Injectable , Inject} from '@angular/core';
import { Http, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BaseEndpoint } from '../../app.constants';
import { GridRequestParams } from '../../shared/_models/GridRequestParams';

@Injectable()
export class UsersService {
    headers: Headers;

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiEndpoint  ) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
    }

    public getSearchUrl(url: string, searchOption: GridRequestParams): string {
        let queryString = '';

        if (searchOption) {
            if (searchOption.pageSize !== undefined) {
                queryString += 'pageSize=' + searchOption.pageSize;
            }
            if (searchOption.paginationStartIndex !== undefined) {
                queryString += queryString.trim() === '' ? 'paginationStartIndex=' : '&paginationStartIndex=';
                queryString += searchOption.paginationStartIndex;
            }
            if (searchOption.searchBy !== undefined && searchOption.searchBy !== '') {
                queryString += queryString.trim() === '' ? 'searchBy=' : '&searchBy=';
                queryString += searchOption.searchBy;
            }
            if (searchOption.sortBy.sortOrder !== undefined) {
                queryString += queryString.trim() === '' ? 'sortBy.sortOrder=' : '&sortBy.sortOrder=';
                queryString += searchOption.sortBy.sortOrder;
            }
            if (searchOption.sortBy.sortColumn !== undefined && searchOption.sortBy.sortColumn !== '') {
                queryString += queryString.trim() === '' ? 'sortBy.sortColumn=' : '&sortBy.sortColumn=';
                queryString += searchOption.sortBy.sortColumn.trim();
            }
            url += queryString.trim() === '' ? '' : '?';
            url += queryString;
        }
        return url;
    }

    public getRoles() {
        return this.http.get(this.baseApiEndpoint + '/roles' ).map(response => {
          return response.json();
        }).catch(err => {
            return Observable.of(err);
        });
    }

    public deleteUser(userId: number) {
        return this.http.delete(this.baseApiEndpoint + '/deleteuser/' + userId).map(response => {
            return response.json()['result'];
          }).catch(err => {
            return Observable.of(err);
          });
    }

    public getUserById(id: number) {
        return this.http.get(this.baseApiEndpoint + '/getuserbyid/' + id).map(response => {
            return response.json()['result'];
        }).catch(err => {
            return Observable.of(err);
        });
    }

    public addUser(user) {
        return this.http.post(this.baseApiEndpoint + '/userroles', user).map(response => {
            return response.json()['result'];
        }).catch(err => {
            return Observable.of(err);
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/users/_services/users.service.ts